<template>
    <div class="p-3">
        <h3>Pasien Tidak Aktif Selama 5 Tahun</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_dari" class="col-sm-4 col-form-label text-end">Dari</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_dari" id="tanggal_dari" class="form-control" v-model="filter.tanggal_dari">
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_sampai" class="col-sm-4 col-form-label text-end">Sampai</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_sampai" id="tanggal_sampai" class="form-control" v-model="filter.tanggal_sampai">
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="mb-3 row">
                    <label for="search" class="col-sm-6 col-form-label text-end">No. RM/Nama/NIK/No Kartu BPJS</label>
                    <div class="col-sm-6">
                        <input type="text" name="search" id="search" class="form-control" v-model="filter.search">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getAllPasien"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Pasien</div>
            <div class="card-body">
                <div id="table-pasien"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables'

export default {
    data() {
        return {
            master_pasiens: [],
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
            },
            table: null
        }
    },
    created() {
        this.filter.page = this.$route.query.page ?? 1
    },
    mounted() {
        this.getAllPasien()
    },
    methods: {
        getAllPasien() {
            const uri = `/api/retensi-dan-pemusnahan/get-all-pasien-tidak-aktif-5-tahun?tanggal_dari=${this.filter.tanggal_dari}&tanggal_sampai=${this.filter.tanggal_sampai}&search=${this.filter.search}`

            const element = document.getElementById('table-pasien')

            const getCountRegs = function (cell, formatterParams) {
                const data = cell.getRow().getData()
                const registers = data.registers

                return registers.length
            }

            const getLastReg = function (cell, formatterParams) {
                const data = cell.getRow().getData()
                const last_reg = data.registers[0]

                return last_reg.Regdate
            }

            this.table = new Tabulator(element, {
                layout: 'fitColumns',
                pagination: 'true',
                paginationMode: 'remote',
                paginationSize: 10,
                paginationSizeSelector:[10, 25, 50, 100, true],
                dataLoader: this.ajaxLoader,
                ajaxURL: uri,
                ajaxResponse: this.AjaxResponse,
                sortMode: 'remote',
                filterMode: 'remote',
                columns: [
                    {title: 'No Rekam Medis', field: 'Medrec'},
                    {title: 'Nama', field: 'Firstname'},
                    {title: 'Tanggal Lahir', field: 'Bod'},
                    {title: 'NIK', field: 'NoIden'},
                    {title: 'No Kartu BPJS', field: 'AskesNo'},
                    {title: 'Tanggal Daftar', field: 'tgl_daftar'},
                    {title: 'Jumlah Registrasi', formatter: getCountRegs},
                    {title: 'Registrasi Terakhir', formatter: getLastReg},
                    {title: 'Status Retensi', field: 'Deleted', formatter: function (cell, formatterParams) {
                        const data = cell.getRow().getData()
                        const deleted = data.Deleted

                        if (deleted) {
                            if (deleted.includes('RETENSI DAN PEMUSNAHAN')) {
                                return 'Retensi'
                            } else {
                                return 'Deleted'
                            }
                        } else {
                            return 'Aktif'
                        }
                    }},
                    {title: 'Action', formatter: function (cell, formatterParams) {
                        const data = cell.getRow().getData()
                        const deleted = data.Deleted

                        if (deleted) {
                            return '<button class="btn btn-sm btn-primary" id="detail">Detail</button>'
                        } else {
                            return '<button class="btn btn-sm btn-primary" id="detail">Detail</button><button class="btn btn-sm btn-danger" id="delete">Delete</button>'
                        }
                    }, cellClick: this.rowActions},
                ]
            })
        },
        ajaxLoader() {
            // set loading screen
        },
        AjaxResponse(url, params, response) {
            return response[0].master_pasiens
        },
        rowActions(e, cell) {
            const id = e.target.id
            switch (id) {
                case 'detail':
                    this.openDetailPage(cell)
                    break
                case 'delete':
                    this.konfirmDeletePasien(cell)
                    break
            
                default:
                    break
            }
        },
        openDetailPage(cell) {
            const data = cell.getRow().getData()
            const medrec = data.Medrec

            this.$router.push({
                name: 'pasien_tidak_aktif_5_tahun_details',
                params: { Medrec: medrec}
            })
        },
        konfirmDeletePasien(cell) {
            const data = cell.getRow().getData()
            this.$swal.fire({
                title: "Yakin?",
                text: "data akan dihapus!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deletePasien(data)
                }
            })
        },
        deletePasien(data_pasien) {
            const uri = '/api/retensi-dan-pemusnahan/delete-pasien'
            const data = {
                medrec: data_pasien.Medrec
            }

            this.axios.post(uri, data).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: "Berhasil!",
                        text: "Data Berhasil Dihapus",
                        icon: "success"
                    });
                    this.getAllPasien()
                } else {
                    this.$swal.fire({
                        title: "Gagal!",
                        text: response.data.message ?? 'Data Gagal Dihapus',
                        icon: "error"
                    });
                }
            })
        },
        resetFilters() {
            this.filter = {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            }

            this.getAllPasien()
        }
    }
}
</script>